(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1203343"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-details')) {
    class BBProductDetails extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('.bb-details__image');
        this.frame = this.querySelector('.bb-details__image-frame');
        this.stage = this.querySelector('.bb-details__stage');
        this.svg = this.querySelector('.bb-details__lines');
        this.desktop = window.matchMedia('(min-width: 990px)');

        if (!this.image || !this.frame || !this.stage || !this.svg) return;

        this.handleLoad = () => this.prepare();
        this.handleMedia = () => this.schedule();
        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this);
        this.desktop.addEventListener('change', this.handleMedia);

        if (this.image.complete && this.image.naturalWidth) {
          this.prepare();
        } else {
          this.image.addEventListener('load', this.handleLoad, { once: true });
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.schedule());
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.desktop && this.handleMedia) this.desktop.removeEventListener('change', this.handleMedia);
        if (this.image && this.handleLoad) this.image.removeEventListener('load', this.handleLoad);
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.drawFrame);
      }

      async prepare() {
        try {
          await this.image.decode();
        } catch (error) {
          if (!this.image.naturalWidth) return;
        }

        this.analysis = this.analyzeImage() || this.createFallbackAnalysis();
        this.schedule();
      }

      schedule() {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.layout());
      }

      median(values) {
        const ordered = values.slice().sort((a, b) => a - b);
        return ordered[Math.floor(ordered.length / 2)] || 0;
      }

      analyzeImage() {
        const naturalWidth = this.image.naturalWidth;
        const naturalHeight = this.image.naturalHeight;
        if (!naturalWidth || !naturalHeight) return null;

        const reduction = Math.min(1, 520 / Math.max(naturalWidth, naturalHeight));
        const width = Math.max(2, Math.round(naturalWidth * reduction));
        const height = Math.max(2, Math.round(naturalHeight * reduction));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return null;

        let pixels;
        try {
          context.drawImage(this.image, 0, 0, width, height);
          pixels = context.getImageData(0, 0, width, height).data;
        } catch (error) {
          return null;
        }

        const border = [];
        const step = Math.max(1, Math.floor(Math.min(width, height) / 70));
        const read = (x, y) => {
          const index = (y * width + x) * 4;
          return [pixels[index], pixels[index + 1], pixels[index + 2], pixels[index + 3]];
        };

        for (let x = 0; x < width; x += step) {
          border.push(read(x, 0), read(x, height - 1));
        }

        for (let y = 0; y < height; y += step) {
          border.push(read(0, y), read(width - 1, y));
        }

        const background = [0, 1, 2, 3].map((channel) => this.median(border.map((sample) => sample[channel])));
        const borderDistances = border.map((sample) => (
          Math.abs(sample[0] - background[0]) +
          Math.abs(sample[1] - background[1]) +
          Math.abs(sample[2] - background[2]) +
          Math.abs(sample[3] - background[3])
        )).sort((a, b) => a - b);
        const backgroundVariation = borderDistances[Math.floor(borderDistances.length * 0.92)] || 0;
        const threshold = Math.min(110, Math.max(30, backgroundVariation + 18));
        const rowLeft = new Int32Array(height);
        const rowRight = new Int32Array(height);
        const rowCount = new Int32Array(height);
        rowLeft.fill(width);
        rowRight.fill(-1);
        let foregroundPixels = 0;

        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const index = (y * width + x) * 4;
            const alpha = pixels[index + 3];
            const colorDistance =
              Math.abs(pixels[index] - background[0]) +
              Math.abs(pixels[index + 1] - background[1]) +
              Math.abs(pixels[index + 2] - background[2]);
            const isForeground = background[3] < 32 ? alpha > 32 : alpha > 24 && colorDistance > threshold;

            if (isForeground) {
              rowLeft[y] = Math.min(rowLeft[y], x);
              rowRight[y] = Math.max(rowRight[y], x);
              rowCount[y] += 1;
              foregroundPixels += 1;
            }
          }
        }

        const minimumRowPixels = Math.max(3, Math.round(width * 0.006));
        let validRows = Array.from({ length: height }, (_, index) => index)
          .filter((row) => rowCount[row] >= minimumRowPixels);

        if (validRows.length < Math.max(12, height * 0.05)) return null;

        const trim = Math.min(6, Math.floor(validRows.length * 0.012));
        if (trim > 0 && validRows.length > trim * 2 + 8) {
          validRows = validRows.slice(trim, validRows.length - trim);
        }

        const minY = validRows[0];
        const maxY = validRows[validRows.length - 1];
        let minX = width;
        let maxX = 0;

        validRows.forEach((row) => {
          minX = Math.min(minX, rowLeft[row]);
          maxX = Math.max(maxX, rowRight[row]);
        });

        const boxWidth = maxX - minX + 1;
        const boxHeight = maxY - minY + 1;
        const coverage = foregroundPixels / (width * height);

        if (boxWidth < width * 0.08 || boxHeight < height * 0.08 || coverage > 0.82) return null;

        return { width, height, minX, maxX, minY, maxY, validRows, rowLeft, rowRight, fallback: false };
      }

      createFallbackAnalysis() {
        const width = Math.max(2, this.image.naturalWidth || 1000);
        const height = Math.max(2, this.image.naturalHeight || 1000);
        const minX = Math.round(width * 0.28);
        const maxX = Math.round(width * 0.72);
        const minY = Math.round(height * 0.34);
        const maxY = Math.round(height * 0.70);
        const rowLeft = new Int32Array(height);
        const rowRight = new Int32Array(height);
        const validRows = [];

        for (let y = minY; y <= maxY; y += 1) {
          rowLeft[y] = minX;
          rowRight[y] = maxX;
          validRows.push(y);
        }

        return { width, height, minX, maxX, minY, maxY, validRows, rowLeft, rowRight, fallback: true };
      }

      layout() {
        if (!this.analysis) return;

        if (!this.desktop.matches) {
          this.classList.remove('bb-details--smart');
          this.style.setProperty('--bb-smart-scale', '1.08');
          this.style.setProperty('--bb-shift-x', '0px');
          this.style.setProperty('--bb-shift-y', '0px');
          this.svg.replaceChildren();
          return;
        }

        const boxRatio = (this.analysis.maxX - this.analysis.minX + 1) / (this.analysis.maxY - this.analysis.minY + 1);
        let stageHeight = 510;
        if (boxRatio > 2) stageHeight = 390;
        else if (boxRatio > 1.45) stageHeight = 450;
        else if (boxRatio < 0.78) stageHeight = 550;

        const widthFactor = Math.min(1, Math.max(0.86, this.clientWidth / 1180));
        stageHeight = Math.round(stageHeight * widthFactor);
        this.style.setProperty('--bb-stage-height', `${stageHeight}px`);

        cancelAnimationFrame(this.drawFrame);
        this.drawFrame = requestAnimationFrame(() => this.drawSmartLayout());
      }

      drawSmartLayout() {
        const analysis = this.analysis;
        const frameWidth = this.frame.clientWidth;
        const frameHeight = this.frame.clientHeight;
        const stageRect = this.stage.getBoundingClientRect();
        const frameRect = this.frame.getBoundingClientRect();
        if (!frameWidth || !frameHeight || !stageRect.width || !stageRect.height) return;

        const sourceRatio = this.image.naturalWidth / this.image.naturalHeight;
        const frameRatio = frameWidth / frameHeight;
        let drawWidth;
        let drawHeight;

        if (sourceRatio > frameRatio) {
          drawWidth = frameWidth;
          drawHeight = frameWidth / sourceRatio;
        } else {
          drawHeight = frameHeight;
          drawWidth = frameHeight * sourceRatio;
        }

        const baseLeft = (frameWidth - drawWidth) / 2;
        const baseTop = (frameHeight - drawHeight) / 2;
        const boxWidth = ((analysis.maxX - analysis.minX + 1) / analysis.width) * drawWidth;
        const boxHeight = ((analysis.maxY - analysis.minY + 1) / analysis.height) * drawHeight;
        const desiredScale = Math.min((frameWidth * 0.88) / boxWidth, (frameHeight * 0.86) / boxHeight);
        const smartScale = analysis.fallback ? 1.08 : Math.min(1.48, Math.max(0.96, desiredScale));
        const manualScale = parseFloat(getComputedStyle(this).getPropertyValue('--bb-image-scale')) || 1;
        const effectiveScale = smartScale * manualScale;
        const boxCenterX = baseLeft + ((analysis.minX + analysis.maxX + 1) / 2 / analysis.width) * drawWidth;
        const boxCenterY = baseTop + ((analysis.minY + analysis.maxY + 1) / 2 / analysis.height) * drawHeight;
        const shiftX = -(boxCenterX - frameWidth / 2) * effectiveScale;
        const shiftY = -(boxCenterY - frameHeight / 2) * effectiveScale;

        this.style.setProperty('--bb-smart-scale', smartScale.toFixed(4));
        this.style.setProperty('--bb-shift-x', `${shiftX.toFixed(2)}px`);
        this.style.setProperty('--bb-shift-y', `${shiftY.toFixed(2)}px`);
        this.classList.add('bb-details--smart');

        const frameLeft = frameRect.left - stageRect.left;
        const frameTop = frameRect.top - stageRect.top;
        const mapX = (sourceX) => (
          frameLeft + frameWidth / 2 +
          (baseLeft + (sourceX / analysis.width) * drawWidth - frameWidth / 2) * effectiveScale + shiftX
        );
        const mapY = (sourceY) => (
          frameTop + frameHeight / 2 +
          (baseTop + (sourceY / analysis.height) * drawHeight - frameHeight / 2) * effectiveScale + shiftY
        );

        this.svg.setAttribute('viewBox', `0 0 ${stageRect.width} ${stageRect.height}`);
        this.svg.replaceChildren();
        this.drawSide('left', mapX, mapY, stageRect);
        this.drawSide('right', mapX, mapY, stageRect);
      }

      drawSide(side, mapX, mapY, stageRect) {
        const rail = this.querySelector(`.bb-details__rail--${side}`);
        const items = Array.from(rail.querySelectorAll('.bb-details__item'));
        const rows = this.analysis.validRows;
        const namespace = 'http://www.w3.org/2000/svg';

        items.forEach((item, index) => {
          const fraction = (index + 1) / (items.length + 1);
          const rowIndex = Math.min(rows.length - 1, Math.max(0, Math.round(fraction * (rows.length - 1))));
          const row = rows[rowIndex];
          const sourceX = side === 'left' ? this.analysis.rowLeft[row] : this.analysis.rowRight[row];
          const connectorRect = item.querySelector('.bb-details__connector').getBoundingClientRect();
          const startX = side === 'left' ? connectorRect.left - stageRect.left : connectorRect.right - stageRect.left;
          const startY = connectorRect.top - stageRect.top + connectorRect.height / 2;
          const targetX = mapX(sourceX);
          const targetY = mapY(row);
          const line = document.createElementNS(namespace, 'line');
          const dot = document.createElementNS(namespace, 'circle');

          line.setAttribute('class', 'bb-details__smart-line');
          line.setAttribute('x1', startX.toFixed(2));
          line.setAttribute('y1', startY.toFixed(2));
          line.setAttribute('x2', targetX.toFixed(2));
          line.setAttribute('y2', targetY.toFixed(2));
          dot.setAttribute('class', 'bb-details__smart-dot');
          dot.setAttribute('cx', targetX.toFixed(2));
          dot.setAttribute('cy', targetY.toFixed(2));
          dot.setAttribute('r', '3.5');
          this.svg.append(line, dot);
        });
      }
    }

    customElements.define('bb-product-details', BBProductDetails);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_4ac8b34"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-editorial-products')) {
  customElements.define('bb-editorial-products', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (!this.isConnected || this.events) return;
      this.track = this.querySelector('[data-track]');
      if (!this.track || this.classList.contains('bb-linea--two-rows')) return;
      this.hovered = false;
      this.focused = false;
      this.touched = false;
      this.events = new AbortController();
      const on = (el, event, fn) => el?.addEventListener(event, fn, {signal:this.events.signal});
      this.mobile = matchMedia('(max-width:749px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      on(this.querySelector('[data-prev]'),'click',() => this.move(-1));
      on(this.querySelector('[data-next]'),'click',() => this.move(1));
      on(this.mobile,'change',() => this.refresh());
      on(this.track,'keydown',e => {
        if (e.target !== this.track || this.mobile.matches) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1); }
      });
      this.resize = new ResizeObserver(() => this.refresh());
      this.resize.observe(this);
      if (this.dataset.autoplay === 'true') {
        this.visible = false;
        this.paused = this.querySelector('[data-pause]')?.getAttribute('aria-pressed') === 'true';
        on(this,'mouseenter',() => {this.hovered=true;this.schedule();});
        on(this,'mouseleave',() => {this.hovered=false;this.schedule();});
        on(this,'focusin',() => {this.focused=true;this.schedule();});
        on(this,'focusout',e => {this.focused=this.contains(e.relatedTarget);this.schedule();});
        on(this.track,'pointerdown',() => {this.touched=true;this.schedule();});
        on(window,'pointerup',() => {this.touched=false;this.schedule();});
        on(window,'pointercancel',() => {this.touched=false;this.schedule();});
        on(this.track,'scroll',() => this.schedule());
        on(document,'visibilitychange',() => this.schedule());
        on(this.motion,'change',() => this.schedule());
        on(this.querySelector('[data-pause]'),'click',e => {
          this.paused=!this.paused;
          e.currentTarget.setAttribute('aria-pressed',String(this.paused));
          e.currentTarget.textContent=this.paused ? 'Reanudar avance' : 'Pausar avance';
          this.schedule();
        });
        this.observer = new IntersectionObserver(entries => {this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});
        this.observer.observe(this);
      }
      this.refresh();
    }
    maximum() { return Math.max(0,this.track.scrollWidth-this.track.clientWidth); }
    refresh() {
      const active=!this.mobile.matches && this.maximum()>2;
      this.querySelectorAll('[data-prev],[data-next],[data-pause]').forEach(el => el.hidden=!active);
      this.track.tabIndex=active ? 0 : -1;
      if(active) this.track.setAttribute('aria-roledescription','carrusel');
      else this.track.removeAttribute('aria-roledescription');
      this.schedule();
    }
    move(direction) {
      if(this.mobile.matches || this.maximum()<=2) return;
      const step=this.track.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(this.track).columnGap)||0);
      const current=this.track.scrollLeft, max=this.maximum();
      let next=current+direction*step;
      if(direction>0 && current>=max-2) next=0;
      if(direction<0 && current<=2) next=max;
      this.track.scrollTo({left:Math.max(0,Math.min(max,next)),behavior:this.motion.matches?'auto':'smooth'});
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.dataset.autoplay!=='true' || !this.isConnected || this.mobile.matches || this.motion.matches || document.hidden || !this.visible || this.hovered || this.focused || this.touched || this.paused || this.maximum()<=2) return;
      this.timer=setTimeout(() => this.move(1),Math.max(3,Number(this.dataset.interval)||5)*1000);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);clearTimeout(this.timer);
      this.events?.abort();this.resize?.disconnect();this.observer?.disconnect();this.events=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_843619b"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bb-size-guide-v2')) return;

  const methods = {
    shoes: [
      ['foot', 'Mi pie', 'Medida de tu pie', 'Mide del talón al dedo más largo. Mide ambos pies y usa el mayor. No agregues centímetros.', '27,3'],
      ['insole', 'Una plantilla', 'Largo de la plantilla', 'Retira la plantilla de un zapato similar que te quede bien y mídela del talón a la punta. Esta medida es distinta a la del pie.', '27,3']
    ],
    jackets: [
      ['back', 'Mi espalda', 'Ancho de tu espalda', 'Usa una camiseta ligera y relaja los hombros. Pide ayuda para medir de hombro a hombro por la espalda, con la cinta recta.', '46,0'],
      ['jacket', 'Una chaqueta', 'Hombros de la chaqueta', 'Extiende una chaqueta que te quede bien, con la espalda hacia arriba. Mide entre las costuras de los hombros.', '46,0']
    ],
    belts: [
      ['belt', 'Una correa', 'Largo del cuero', 'Extiende una correa que te quede bien y mide desde donde empieza el cuero hasta la punta. No incluyas la hebilla ni uses la medida de tu cintura.', '109']
    ]
  };
  const format = (number) => number.toLocaleString('es-CO', { maximumFractionDigits: 2 });

  function parseTable(raw, belt) {
    const rows = raw.trim().split(/\r?\n/).filter((line) => line.trim()).map((line) => {
      const parts = line.split('|').map((part) => part.trim());
      if (parts.length !== (belt ? 2 : 3) || !parts[0]) throw Error('table');
      const numbers = parts.slice(1).map((part) => /^\d+(?:[.,]\d+)?$/.test(part) ? Number(part.replace(',', '.')) : NaN);
      if (numbers.some((number) => !Number.isFinite(number) || number <= 0) || (!belt && numbers[0] > numbers[1])) throw Error('table');
      return { size: parts[0], min: numbers[0], max: belt ? numbers[0] : numbers[1] };
    });
    if (!rows.length || new Set(rows.map((row) => row.size)).size !== rows.length) throw Error('table');
    rows.forEach((row, index) => {
      if (index && (row.min < rows[index - 1].max || row.max <= rows[index - 1].max)) throw Error('table');
    });
    return rows;
  }

  function match(rows, measurement, belt) {
    if (measurement < rows[0].min || measurement > rows[rows.length - 1].max) return [];
    if (belt) {
      const distance = Math.min(...rows.map((row) => Math.abs(row.min - measurement)));
      return rows.filter((row) => Math.abs(Math.abs(row.min - measurement) - distance) < 0.000001);
    }
    return rows.filter((row, index) => measurement <= row.max && (index && row.min === rows[index - 1].max ? measurement > row.min : measurement >= row.min));
  }

  class BBSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      if (!this.querySelector('[data-edit]')) {
        if (!this.pending) {
          this.pending = new MutationObserver(() => this.connectedCallback());
          this.pending.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      this.pending?.disconnect();
      this.pending = null;
      this.events = new AbortController();
      this.tables = new Map();
      this.form = this.querySelector('form');
      this.category = this.querySelector('[data-category]');
      this.method = this.querySelector('[data-method]');
      this.input = this.querySelector('[data-measure]');
      this.label = this.querySelector('[data-measure-label]');
      this.result = this.querySelector('[data-result]');
      this.panel = this.querySelector('[data-result-panel]');
      this.resultHeading = this.querySelector('[data-result-heading]');
      this.fit = this.querySelector('[data-fit]');
      this.size = this.querySelector('[data-size]');
      this.error = this.querySelector('[data-error]');
      this.errorHelp = this.querySelector('[data-error-help]');
      this.instruction = this.querySelector('[data-instruction]');
      this.help = this.querySelector('[data-guide-help]');
      const on = (element, event, callback) => element.addEventListener(event, callback, { signal: this.events.signal });
      on(this.category, 'change', () => this.setCategory());
      on(this.method, 'change', () => this.setMethod());
      on(this.input, 'input', () => this.reset());
      on(this.form, 'submit', (event) => {
        event.preventDefault();
        this.calculate();
      });
      on(this.querySelector('[data-edit]'), 'click', () => {
        this.reset();
        this.input.focus({ preventScroll: true });
      });
      this.setCategory();
      this.querySelector('fieldset').disabled = false;
    }

    disconnectedCallback() {
      this.pending?.disconnect();
      this.pending = null;
      this.events?.abort();
      this.events = null;
    }

    reset() {
      this.dataset.view = 'entry';
      this.fit.hidden = true;
      this.fit.textContent = '';
      this.size.textContent = '—';
      this.result.textContent = 'Ingresa tu medida y pulsa «Ver mi talla».';
      this.error.textContent = '';
      this.error.hidden = true;
      if (this.errorHelp) this.errorHelp.hidden = true;
      this.input.removeAttribute('aria-invalid');
    }

    setCategory() {
      if (!methods[this.category.value]) this.category.value = 'shoes';
      this.method.replaceChildren(...methods[this.category.value].map(([value, label]) => new Option(label, value)));
      this.setMethod();
    }

    setMethod() {
      const active = methods[this.category.value].find(([value]) => value === this.method.value);
      this.input.value = '';
      this.label.textContent = active[2];
      this.instruction.textContent = active[3];
      this.input.placeholder = `Ej.: ${active[4]}`;
      this.reset();
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      if (this.errorHelp) this.errorHelp.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus({ preventScroll: true });
    }

    calculate() {
      this.reset();
      const raw = this.input.value.trim();
      const measurement = Number(raw.replace(',', '.'));
      if (!/^\d+(?:[.,]\d{1,2})?$/.test(raw) || !Number.isFinite(measurement) || measurement <= 0) {
        this.showError('Escribe una medida mayor que cero, con máximo dos decimales.');
        return;
      }
      const key = this.method.value;
      const belt = key === 'belt';
      let rows = this.tables.get(key);
      try {
        if (!rows) {
          rows = parseTable(this.dataset[key] || '', belt);
          this.tables.set(key, rows);
        }
      } catch (_error) {
        this.showError('No pudimos consultar esta tabla. Revisa la guía de esta página o escríbenos para elegir tu talla.');
        return;
      }
      const found = match(rows, measurement, belt);
      if (!found.length) {
        this.showError('Esta medida necesita revisión. Comprueba cómo mediste o consulta con una asesora.');
        return;
      }
      this.size.textContent = found.map((row) => row.size).join(' / ');
      if (this.category.value === 'jackets' && found.length === 1) {
        const next = rows[rows.indexOf(found[0]) + 1];
        this.fit.textContent = next
          ? `¿La prefieres más holgada? Considera la talla ${next.size} para tener más amplitud.`
          : 'Si buscas más amplitud, escríbenos para revisar el ajuste antes de elegir.';
        this.fit.hidden = false;
      }
      this.result.textContent = belt
        ? found.length > 1
          ? `Tu correa de ${format(measurement)} cm queda entre dos largos: ${found.map((row) => `${format(row.min)} cm (talla ${row.size})`).join(' y ')}. Consúltanos antes de elegir.`
          : `Largo más cercano: ${format(found[0].min)} cm de cuero. Tu medida: ${format(measurement)} cm, sin hebilla.`
        : `${this.label.textContent} · ${format(measurement)} cm`;
      this.input.blur();
      this.help.open = false;
      this.dataset.view = 'result';
      this.resultHeading.focus({ preventScroll: true });
      const bounds = this.panel.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
        this.panel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }
    }
  }
  customElements.define('bb-size-guide-v2', BBSizeGuide);
})();
  } catch(e) { console.error(e); }
})();

})();
